import { Button, Input } from "antd";
import Container from "components/Desktop/Container";
import Header from "components/Desktop/Header";
import ForgetPasswordIcon from "icons/ForgetPasswordIcon";
const ForgetPasswordPage = () => {
  return (
    <div>
      <Container>
        <Header />
      </Container>
      <Container>
        <main className="min-h-[700px] bg-[#F7F4FA] pt-8 p-4 flex justify-center">
          <div className="w-[600px] bg-[#F7F4FAE5] flex flex-col gap-14">
            <div className="text-center text-xl text-primary-700 mt-20">
              ลืมรหัสผ่าน
            </div>
            <div>
              ขั้นตอนการรีเซ็ตรหัสผ่าน
              <div>
                1. ใส่อีเมลที่ใช้สมัครสมาชิกแล้วกดปุ่ม "รีเซ็ตรหัสผ่าน"
                จากนั้นรอรับอีเมลจากระบบ
              </div>
              <div>
                2. อ่านขั้นตอนในการตั้งค่ารหัสผ่านใหม่ในอีเมลที่ได้รับ หากไม่พบ
                ลองดูในถังขยะ
              </div>
            </div>
            <div>
              <Input size="large" placeholder="อีเมล" />
            </div>
            <div className="text-center">
              <Button
                className="w-[200px]"
                size="large"
                type="primary"
                icon={<ForgetPasswordIcon />}
              >
                รีเซ็ทรหัสผ่าน
              </Button>
            </div>
          </div>
        </main>
      </Container>
    </div>
  );
};
export default ForgetPasswordPage;
